import { useSession } from "PFApp/use_session";
import ToastWrap from "PFComponents/growl/toast";
import { fetchCurrentProfile } from "PFCore/services/current_profile";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";

const NOTICE_WINDOW = 15 * 1000; // 15 seconds

const LiveSessionCheck = ({ ttl }) => {
  const [active, setActive] = useState(true);
  const [timeoutId, setTimeoutId] = useState(null);

  const { expireSession } = useSession();

  useEffect(() => {
    if (!active) {
      const id = window.setTimeout(() => {
        if (!active) {
          expireSession("sign_in.session_inactive");
        }
      }, NOTICE_WINDOW); // 1.minute
      setTimeoutId(id);
    } else {
      window.clearTimeout(timeoutId);
    }
  }, [active]);

  const handleOnIdle = () => {
    setActive(false);
  };

  const handleOnActive = () => {
    setActive(true);
    fetchCurrentProfile(); // Make request to API to stay alive
  };

  const handleOnAction = () => {
    setActive(true);
  };

  useIdleTimer({
    timeout: ttl - NOTICE_WINDOW,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500
  });

  return (
    !active && <ToastWrap kind="snackbar" text="Your session will be closed due to inactivity" show={true} />
  );
};

LiveSessionCheck.propTypes = {
  ttl: PropTypes.number
};

export default LiveSessionCheck;
